export function articleContentLangWithLimit(content) {

    return typeof content !== "undefined" ? (content.replace(/<[^>]*>?/gm, '').replace(/"/g, "'").substr(0, 100)) : ""
}

export function timeStampToString(ts) {
    const date = new Date(ts * 1000)
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + ' - ' + date.getHours() + ':' + date.getMinutes()
}

export function timeObjToString(date) {
    return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate() + ' - ' + date.getHours() + ':' + date.getMinutes()
}

export function timeStampToPostString(ts) {
    const date = new Date(ts * 1000)
    return (date.getMonth() + 1) + '月' + date.getDate() + '日' + ' - ' + date.getHours() + ':' + date.getMinutes()
}

export function isValidEmail(email) {
    return typeof email === 'string' ? !(email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) : false;
}

export function isSchoolEmail(email) {
    return isValidEmail(email) ? email.split('@')[1].includes('.edu') : false;
}
